{
  "close": "Uždaryti",
  "notifications": "{count, plural, one {# pranešimas} other {# pranešimai}}."
}
